module.exports = __webpack_public_path__ + "static/media/arm.dd2863d1.png";